// @flow
import moment from 'moment';
import type { StepInMinutes } from '../reach';

const MOMENT_TIME_FORMAT = 'HH:mm:ss';

class Time {
  time: moment;

  constructor(time: moment) {
    this.time = time;
  }

  floorMinutes(intervalInMinutes: StepInMinutes) {
    const { time } = this;

    const floored = time.clone()
      .minutes(Math.floor(time.minutes() / intervalInMinutes) * intervalInMinutes)
      .seconds(0);

    return new Time(floored);
  }

  ceilMinutes(intervalInMinutes: StepInMinutes) {
    const { time } = this;

    const minutes = Math.ceil(time.minutes() / intervalInMinutes) * intervalInMinutes;
    const ceiled = time.clone()
      .minutes(minutes === 60 ? 59 : minutes)
      .seconds(minutes === 60 ? 59 : 0);

    return new Time(ceiled);
  }

  is(other: Time) {
    return this.toISO() === other.toISO();
  }

  asMoment() {
    return this.time.clone();
  }

  toISO() {
    return this.time.format(MOMENT_TIME_FORMAT);
  }

  static parse(toParse: string) {
    const time = moment.utc(toParse, 'HH:mm:ss');
    return new Time(time);
  }
}

export default Time;



// WEBPACK FOOTER //
// ./src/statsradio/domain/time/Time.js